import React, { useState } from 'react';
import { Card, Form, Input, Button, Typography, message, Layout, Result } from 'antd';
import { MailOutlined, GithubOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { submitApplication } from '../services/api';

const { Title, Paragraph } = Typography;
const { Content } = Layout;

const ApplyPage: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const onFinish = async (values: { email: string }) => {
    setLoading(true);
    try {
      const res = await submitApplication(values.email);
      if (res.data.success) {
        setSubmitted(true);
      } else {
        message.error(res.data.message);
      }
    } catch (err: any) {
      const msg = err.response?.data?.message || '提交失败，请稍后重试';
      message.error(msg);
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <Layout style={{ minHeight: '100vh', background: '#f0f2f5' }}>
        <Content style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Result
            status="success"
            title="申请已提交"
            subTitle="请等待管理员审核，审核通过后您将收到 GitHub 组织邀请邮件"
            extra={[
              <Button key="status" type="primary" onClick={() => navigate('/status')}>
                查询申请状态
              </Button>,
              <Button key="back" onClick={() => { setSubmitted(false); form.resetFields(); }}>
                返回
              </Button>,
            ]}
          />
        </Content>
      </Layout>
    );
  }

  return (
    <Layout style={{ minHeight: '100vh', background: '#f0f2f5' }}>
      <Content style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '24px' }}>
        <Card style={{ width: 480, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
          <div style={{ textAlign: 'center', marginBottom: 32 }}>
            <GithubOutlined style={{ fontSize: 48, color: '#24292e' }} />
            <Title level={3} style={{ marginTop: 16 }}>GitHub 组织邀请申请</Title>
            <Paragraph type="secondary">
              请输入您的邮箱地址，提交后管理员将审核您的申请
            </Paragraph>
          </div>
          <Form form={form} onFinish={onFinish} layout="vertical" size="large">
            <Form.Item
              name="email"
              rules={[
                { required: true, message: '请输入邮箱地址' },
                { type: 'email', message: '请输入有效的邮箱地址' },
              ]}
            >
              <Input
                prefix={<MailOutlined />}
                placeholder="请输入您的邮箱地址"
              />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" block loading={loading}>
                提交申请
              </Button>
            </Form.Item>
          </Form>
          <div style={{ textAlign: 'center' }}>
            <Button type="link" onClick={() => navigate('/status')}>
              已提交？查询申请状态
            </Button>
          </div>
        </Card>
      </Content>
    </Layout>
  );
};

export default ApplyPage;
